import React, { useEffect, useState } from 'react';
import { Checkbox, LABEL_PLACEMENT } from 'baseui/checkbox';
import { Questions } from './helpers/preferencesQuestions';
import {
  cannonStyled,
  TWH5,
  TWParagraph3,
  useCannonStyletron,
} from '../../../theme';
import { Button, TextAreaInput } from '../../../atoms';
import { useTableOrMobile } from '../../../hooks';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { preferences } from 'joi';

export interface IPreferences {
  suggestion: string;
  questions: Array<{
    question: string;
    answer: string;
    options: { label: string }[];
  }>;
}

const MainContainer = cannonStyled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
});

const QuestionContainer = cannonStyled(
  'div',
  ({ isMobile }: { isMobile: boolean }) => ({
    padding: '30px 0px 0px 0px',
    maxWidth: isMobile ? '80vw' : '50vw',
  })
);

const SubmitButtonContainer = cannonStyled('div', {
  marginTop: '60px',
  width: '40%',
});

const ButtonsContainer = cannonStyled('div', {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

interface Props {
  stepPassed: (value: IPreferences) => void;
}

const Preferences = ({ stepPassed }: Props) => {
  // HOOKS
  const [css, theme] = useCannonStyletron();
  const [isMobile] = useTableOrMobile();

  // STATE
  const [questions, setQuestions] = useState({
    suggestion: '',
    questions: Questions,
  });

  const [numberTest, setNumberTest] = useState(0);
  useEffect(() => {}, [questions.suggestion]);

  // EFFECTS

  useEffect(() => {
    setTimeout(() => {
      scrollTo('#register-your-safe-main-container');
    }, 200);
  }, []);

  // HANDLERS && FUNCTIONS

  const handleChange = (value: string, index: number) => {
    const tmp = { ...questions };
    if (index === 99) {
      tmp.suggestion = value;
    } else {
      tmp.questions[index].answer = value;
    }
    setQuestions(tmp);
  };
  //EFFECTS
  
  // RENDER
  return (
    <MainContainer>
      <div>
        <TextAreaInput
          noMarginLeft
          rows={4}
          errorMessage='Field Required'
          placeholder='I have a problem with my safe lock'
          error={undefined}
          positive={questions.suggestion !== ''}
          label='Any suggestions for us?'
          value={questions.suggestion}
          onChange={(e: any) => handleChange(e.currentTarget.value, 99)}
        />
        {questions.questions.map((item, index) => {
          return (
            <QuestionContainer isMobile={isMobile}>
              <TWH5
                margin={10}
                color={theme.cannonColors.primaryBlue}
                weight={700}
                align='left'
                $style={{ fontSize: '20px' }}
              >
                {item.question}
              </TWH5>
              <div>
                {item.options.map((option) => {
                  const { label = '' } = option;
                  const _label1 = label.includes('(')
                    ? label.split('(')[0]
                    : label;
                  const _label2 = label.includes('(')
                    ? '('.concat(label.split('(')[1])
                    : '';
                  const _label3 = label.includes('(')
                    ? label.split(')')[1]
                    : '';
                  return (
                    <Checkbox
                      checked={item.answer === option.label}
                      onChange={() => handleChange(option.label, index)}
                      overrides={{
                        Checkmark: {
                          style: {
                            borderLeftColor: theme.cannonColors.primaryBlue,
                            borderRightColor: theme.cannonColors.primaryBlue,
                            borderTopColor: theme.cannonColors.primaryBlue,
                            borderBottomColor: theme.cannonColors.primaryBlue,
                            borderTopLeftRadius: '5px',
                            borderTopRightRadius: '5px',
                            borderBottomLeftRadius: '5px',
                            borderBottomRightRadius: '5px',
                            borderWidth: '2px',
                          },
                        },
                      }}
                      labelPlacement={LABEL_PLACEMENT.right}
                    >
                      <TWParagraph3
                        align='left'
                        weight={400}
                        color={theme.cannonColors.primaryGray}
                        $style={{ fontSize: '18px', paddingBottom: '10px' }}
                      >
                        {_label1}
                        <span
                          style={{
                            color: theme.cannonColors.secondarySilver,
                          }}
                        >
                          {_label2}
                        </span>
                        {_label3}
                      </TWParagraph3>
                    </Checkbox>
                  );
                })}
              </div>
            </QuestionContainer>
          );
        })}
      </div>
      <ButtonsContainer>
        <SubmitButtonContainer>
          <Button.RoundedButton
            onClick={() => stepPassed(questions)}
            size='compact'
            type='submit'
            color='primary'
            fullWidth
          >
            Submit
          </Button.RoundedButton>
        </SubmitButtonContainer>
      </ButtonsContainer>
    </MainContainer>
  );
};

export default Preferences;
